import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Payment } from '../../stp-registration/models/payment.model';
import { PaymentType } from '../../payment/models/payment_type.model';

@Injectable()
export class PaymentTransactionService {
  onRefreshPaymentMainList = new Subject<Payment[]>();
  paymentMains: Payment[] = [];

  onRefreshPaymentTypeList = new Subject<PaymentType[]>();
  paymentTypes: PaymentType[] = [];

  constructor(
  ) { }

  setPaymentMains(paymentMains: Payment[]): void {
    this.paymentMains = paymentMains;
    this.onRefreshPaymentMainList.next(this.paymentMains.slice());
  }


  getPaymentTypes(): PaymentType[] {
    return this.paymentTypes;
  }

  // getPaymentTypeById(id: number | null): PaymentType | undefined {
  //   return this.paymentTypes.find((paymentType) => paymentType.id === id);
  // }

  setPaymentTypes(paymentTypes: PaymentType[]): void {
    this.paymentTypes = paymentTypes;
    this.onRefreshPaymentTypeList.next(this.paymentTypes.slice());
  }

  // addPaymentType(paymentType: PaymentType): void {
  //   this.paymentTypes.push(paymentType);
  //   this.onRefreshPaymentTypeList.next(this.paymentTypes.slice());
  // }

  // upatedPaymentType(newRecipe: PaymentType, id: number): void {
  //   const index = this.paymentTypes.findIndex(
  //     (paymentType) => paymentType.id === id
  //   );
  //   this.paymentTypes[index] = newRecipe;
  //   this.onRefreshPaymentTypeList.next(this.paymentTypes.slice());
  // }

  // deletePaymentType(id: number): void {
  //   this.paymentTypes = this.paymentTypes.filter((paymentType) => {
  //     return paymentType.id !== id;
  //   });
  //   this.onRefreshPaymentTypeList.next(this.paymentTypes.slice());
  // }

  // getEditingPaymentTypeId(): any {
  //   return this.editingPaymentTypeId;
  // }

  // setEditingPaymentTypeId(id: number): void {
  //   this.editingPaymentTypeId = id;
  //   this.onStartPaymentTypeEditing.next(id);
  // }

  // clearEditingPaymentTypeId(): void {
  //   this.editingPaymentTypeId = null;
  //   this.onStartPaymentTypeEditing.next(null);
  // }

  // clearPaymentTypes(): void {
  //   this.paymentTypes = [];
  //   this.onRefreshPaymentTypeList.next([]);
  // }


}
